import Container, { Service } from 'typedi';
import { WindowToken } from '../../../injection-tokens';
import { ILogger } from '@sparkware/uc-sdk-core';
import { LoggerProvider } from '../../logger';
import { IdsOfElements } from '../../../models/enums/general-enums';

//This is the file PF.WEB.UI.OMGUIManager.ts migrated.
@Service()
export class OMGUIManager {
    private _omgShown: boolean = false;
    private readonly _window: Window;
    private readonly _logger: ILogger;

    private readonly MOBILE_MAX_HEIGHT_PORTRAIT = 1023;
    private readonly MOBILE_MAX_WIDTH_PORTRAIT = 767;
    private readonly MOBILE_MAX_HEIGHT_LANDSCAPE = 767;
    private readonly MOBILE_MAX_WIDTH_LANDSCAPE = 1023;
    private readonly MOBILE_HEIGHT_LANDSCAPE_SIZE = 90;
    private readonly MOBILE_WIDTH_LANDSCAPE_SIZE = 80;
    private readonly TABLET_HEIGHT_LANDSCAPE_SIZE = 35;
    private readonly TABLET_WIDTH_LANDSCAPE_SIZE = 60;
    private readonly MOBILE_HEIGHT_PORTRAIT_SIZE = 90;
    private readonly MOBILE_WIDTH_PORTRAIT_SIZE = 80;
    private readonly TABLET_HEIGHT_PORTRAIT_SIZE = 50;
    private readonly TABLET_WIDTH_PORTRAIT_SIZE = 40;

    public get omgShown(): boolean {
        return this._omgShown;
    }

    public set omgShown(value: boolean) {
        this._omgShown = value;
    }

    constructor() {
        this._logger = Container.get(LoggerProvider).getLogger('OMGUIManager');
        this._window = Container.get(WindowToken);
    }

    public updateContainerSize(width: number, height: number): void {
        this._logger.debug('in updateContainerSize. width: ', width, ' height ', height);
        const omgIframe = this._window.document.getElementById(
            IdsOfElements.OmgGeneralIframe,
        ) as HTMLIFrameElement;
        if (!omgIframe) return;

        omgIframe.removeAttribute('style');

        if (width !== -1) {
            // set omg pc size
            omgIframe.height = height.toString();
            omgIframe.width = width.toString();

            const closeButtonWrapDiv = this._window.document.getElementById('closeButtonWrapDiv');
            if (closeButtonWrapDiv && omgIframe) {
                omgIframe.style.display = 'none';
            }
        } else {
            // set omg mobile size
            this._setOMGIframeSize();
            this._centerOMG();
        }
    }

    public handleOrientationChange(): void {
        if (this._omgShown) {
            const omgIframe = this._window.document.getElementById(
                IdsOfElements.OmgGeneralIframe,
            ) as HTMLIFrameElement;
            if (!omgIframe) return;

            const deviceData = this._window.pageContextManager.getDeviceData();

            omgIframe.height = '0';
            omgIframe.width = '0';

            if (deviceData.isMobile) {
                omgIframe.classList.add('noBorder');
            }

            setTimeout(() => {
                const wrapDiv = this._window.document.getElementById('WrapDiv');
                if (wrapDiv?.style.display !== 'none') {
                    this._setOMGIframeSize();
                    this._centerOMG();
                    if (deviceData.isMobile) {
                        omgIframe.classList.remove('noBorder');
                    }
                }
            }, 600);
        } else {
            const generalIframe = this._window.document.getElementById(
                IdsOfElements.GeneralIframe,
            ) as HTMLIFrameElement;
            if (!generalIframe) return;

            generalIframe.setAttribute('style', 'height: ' + this._window.innerHeight + 'px');
        }
    }

    private _setOMGIframeSize(): void {
        let sizeMultiplierWidth: number;
        let sizeMultiplierHeight: number;

        const omgIframe = this._window.document.getElementById(
            IdsOfElements.OmgGeneralIframe,
        ) as HTMLIFrameElement;
        if (!omgIframe) return;

        if (this._window.innerHeight > this._window.innerWidth) {
            // portrait mode
            if (
                this._window.innerHeight <= this.MOBILE_MAX_HEIGHT_PORTRAIT &&
                this._window.innerWidth <= this.MOBILE_MAX_WIDTH_PORTRAIT
            ) {
                sizeMultiplierWidth = this.MOBILE_WIDTH_PORTRAIT_SIZE / 100;
                sizeMultiplierHeight = this.MOBILE_HEIGHT_PORTRAIT_SIZE / 100;
            } else {
                sizeMultiplierWidth = this.TABLET_WIDTH_PORTRAIT_SIZE / 100;
                sizeMultiplierHeight = this.TABLET_HEIGHT_PORTRAIT_SIZE / 100;
            }
        } else {
            // landscape mode
            if (
                this._window.innerHeight <= this.MOBILE_MAX_HEIGHT_LANDSCAPE &&
                this._window.innerWidth <= this.MOBILE_MAX_WIDTH_LANDSCAPE
            ) {
                sizeMultiplierWidth = this.MOBILE_WIDTH_LANDSCAPE_SIZE / 100;
                sizeMultiplierHeight = this.MOBILE_HEIGHT_LANDSCAPE_SIZE / 100;
            } else {
                sizeMultiplierWidth = this.TABLET_WIDTH_LANDSCAPE_SIZE / 100;
                sizeMultiplierHeight = this.TABLET_HEIGHT_LANDSCAPE_SIZE / 100;
            }
        }

        omgIframe.height = (this._window.innerHeight * sizeMultiplierHeight).toString();
        omgIframe.width = (this._window.innerWidth * sizeMultiplierWidth).toString();
    }

    private _centerOMG(): void {
        const omgIframe = this._window.document.getElementById(
            IdsOfElements.OmgGeneralIframe,
        ) as HTMLIFrameElement;
        if (!omgIframe) return;

        const iframeHeight = parseInt(omgIframe.height);
        const iframeWidth = parseInt(omgIframe.width);

        const top = this._window.innerHeight - iframeHeight;
        const left = this._window.innerWidth - iframeWidth;

        omgIframe.style.margin = '0';
        omgIframe.style.marginTop = `${top / 2}px`;
        omgIframe.style.top = '0%';
        omgIframe.style.left = 'auto';
    }
}
